<template>
  <div ref="stamped-io-feed" class="stamped-io-feed">
    <h3
      v-if="!showAtPage"
      class="stamped-io-feed__title section section--universal"
    >
      <nuxt-link to="/shopinsta">{{ $t('home.foursixty') }}</nuxt-link>
      <span class="stamped-io-feed__instagram">@{{ instaHandle }}</span>
    </h3>
    <h1
      v-if="showAtPage"
      class="stamped-io-feed__title_page section section--universal"
    >
      {{ $t('home.foursixty') }}
    </h1>
    <div class="stamped-io-feed__content">
      <div
        id="stamped-reviews-widget"
        v-intersect.once.quiet="onIntersection"
        data-widget-type="instagram-feed"
        data-fill-empty="true"
        :data-take="4"
        :class="[
          'stamped-io-feed__container',
          'mobile-only',
          { 'stamped-io-feed__show-load-more': !showAtPage },
        ]"
      ></div>
      <div
        id="stamped-reviews-widget"
        v-intersect.once.quiet="onIntersection"
        data-widget-type="instagram-feed"
        data-fill-empty="true"
        :data-take="12"
        :class="[
          'stamped-io-feed__container',
          'desktop-only',
          { 'stamped-io-feed__show-load-more': !showAtPage },
        ]"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import stampediolable from '~/mixins/stampediolable'

export default {
  name: 'StampedIoFeed',
  mixins: [stampediolable],
  props: {
    showAtPage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['storeCode']),
    instaHandle() {
      return this.storeCode === 'br' ? 'gocasebr' : 'gocase'
    },
  },
  mounted() {
    if (this.showAtPage) {
      this.setCredentials()
      this.loadStampedScript().then(this.initStamped)
    }
  },
  methods: {
    onIntersection(entreis, observer, isIntersecting) {
      if (isIntersecting) {
        this.setCredentials()
        this.loadStampedScript().then(this.initStamped)
      }
    },
  },
}
</script>

<style lang="scss">
.stamped-io-feed {
  padding-top: 5px;
  min-height: 0;
  margin-bottom: 1px;

  .stamped-io-feed__show-load-more {
    .stamped-instagram-load-more {
      display: none !important;
    }
  }

  .stamped-io-feed__title,
  .stamped-io-feed__title_page {
    text-align: center;
    font-size: 18px;
    line-height: 1.1;
    font-weight: 700;
    color: $v4_color_text;
    margin-bottom: 15px;
    margin-top: 0;

    a {
      color: $v4_color_text;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .stamped-io-feed__title_page {
    font-size: 35px;
    font-weight: 500;
    margin: 20px 0px;
  }

  .stamped-io-feed__instagram {
    font-size: 13px;
    font-weight: normal;
    display: block;
  }

  @media (min-width: $v4_desktop) {
    padding-top: 60px;
  }
}

.stamped-io-feed__content {
  &::before,
  &::after {
    content: '';
    clear: both;
    display: table;
  }
}

@media (max-width: $screen_tablet) {
  .stamped-io-feed {
    margin-top: 20px;

    .fs-entry-container {
      width: 50%;
      padding-top: 50%;
    }
    .fs-entry-container:nth-child(n + 5) {
      display: none;
    }
  }
}

@media (min-width: $screen_tablet) {
  .stamped-io-feed {
    .stamped-io-feed__title {
      font-size: 27px;
    }
    .stamped-io-feed__instagram {
      margin-top: 5px;
      font-size: 16px;
    }
  }
}
</style>
